module.exports = __webpack_public_path__ + "img/group-selection.0c0c092f.png";